import { AppDispatch } from "@Reducers/index";
import { t } from "@i18n";
import type { TranslatedString } from "@i18n";
import { TOAST_TYPE_WARNING } from "../services/constants";
import { showToastNotification } from "../reducers/toastSlice";

export function fileFormatNotSupportedToast() {
  return async (dispatch: AppDispatch) => {
    dispatch(
      showToastNotification({
        content: t("Merge cannot be done for this combination Please try again with supported files or estimates."),
        type: TOAST_TYPE_WARNING,
      }),
    );
  };
}

export function UnnamedEstimateNotSupportedToast(errorMessage: TranslatedString) {
  return async (dispatch: AppDispatch) => {
    dispatch(
      showToastNotification({
        content: errorMessage,
        type: TOAST_TYPE_WARNING,
      }),
    );
  };
}
